import { Component, OnInit } from '@angular/core';
import { SupplierService } from 'src/app/core/services/supplier.service';
import { SupplierItem } from 'src/app/core/models/supplier-control.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from 'src/app/shared/widget/notification/toast-service';

@Component({
  selector: 'app-supplier-control',
  templateUrl: './supplier-control.component.html',
  styleUrls: ['./supplier-control.component.scss'],
})
export class SupplierControlComponent implements OnInit {
  //TODO: Inserir tooltip com os modelos e status para deixar a primeira tabela mais clean
  //TODO: No grid, colocar um botão para edição
  //TODO: Criar um filtro de Agrupador e Agrupador
  //TODO: Depois de inserir um item, ele insere porém informa uma mensagem de erro no front (provavelmente o retorno aqui esta sendo tratado errado)

  constructor(
    public supplierItemService: SupplierService,
    private modalService: NgbModal,
    public formBuilder: UntypedFormBuilder,
    public toastService: ToastService
  ) {}

  supplierItem: SupplierItem[] = [];
  tableSupplierHTMLString: string = '';
  tableGroupingList: string[] = ['Rastreador'];
  tableGroupList: string[] = [];
  public allowExclude: boolean = false;

  valueLocalInserNewField: string = '';

  groupSelect: string[] = [];

  public newSupplierItem: SupplierItem = {
    id: -1,
    supplierName: '',
    grouping: '',
    group: '',
    itemModel: '',
    status: '',
  };
  public idUpdateSupplierItem = -1;
  public exludeItemConfirm = false;
  public updateSupplierItem: SupplierItem = {
    id: -1,
    supplierName: '',
    grouping: '',
    group: '',
    itemModel: '',
    status: '',
  };
  filterModel: string[] = [];
  filterModelBlock: boolean = false;

  tableSupplierItemHeader: SupplierItemHeader = {
    supplier: [],
    grouping: [
      {
        grouping: 'Rastreador',
        group: [],
      },
    ],
    itemModel: [],
  };

  circularProgressiveWait: Boolean = true;

  ngOnInit() {
    this.initializeTable();
  }

  initializeTable() {
    this.supplierItemService.getItemSupplier().subscribe(
      (supplierItem) => {
        this.supplierItem = supplierItem;
        this.createHeader(supplierItem).then(() => {
          this.createTable().then(() => {
            this.circularProgressiveWait = false;
          });
        });
      },
      (error: HttpErrorResponse) => {
        this.circularProgressiveWait = false;
        alert(error.message);
        this.toastService.show('Erro ao carregar tabela - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }
  insertNewSupplierItem() {
    this.supplierItemService
      .postInsertItemSupplier(this.newSupplierItem)
      .subscribe(
        (response: any) => {
          this.toastService.show('Inserido com sucesso', {
            classname: 'bg-success text-center text-white',
            delay: 10000,
          });
          this.initializeTable();
        },
        (error: HttpErrorResponse) => {
          alert(error.message);
          this.toastService.show('Erro ao inserir - ' + error.message, {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
        }
      );
  }
  insertSupplierLocal(newSupplier: string) {
    this.tableSupplierItemHeader.supplier.indexOf(newSupplier) == -1
      ? this.tableSupplierItemHeader.supplier.push(newSupplier)
      : null;
  }
  insertGroupLocal(newGrouping: string, newGroup: string) {
    var indexGroup = this.tableGroupList.indexOf(newGrouping);
    if (indexGroup == -1) {
      this.tableSupplierItemHeader.grouping.push({
        grouping: newGrouping,
        group: [newGroup],
      });
      this.tableGroupingList.push(newGrouping);
      this.tableGroupList.push(newGroup);
    } else {
      this.tableSupplierItemHeader.grouping[indexGroup].group.push(newGroup);
      this.tableGroupList.push(newGroup);
    }
  }
  async createHeader(supplierItem: SupplierItem[]) {
    supplierItem.forEach((item) => {
      this.tableSupplierItemHeader.supplier.indexOf(item.supplierName) == -1
        ? this.tableSupplierItemHeader.supplier.push(item.supplierName)
        : null;
      var filterGroup = this.tableSupplierItemHeader.grouping.findIndex(
        (grouping) => {
          return grouping.grouping == item.grouping;
        }
      );
      if (filterGroup != -1) {
        if (
          this.tableSupplierItemHeader.grouping[filterGroup].group.indexOf(
            item.group
          ) == -1
        ) {
          this.tableSupplierItemHeader.grouping[filterGroup].group.push(
            item.group
          );
          this.tableGroupList.push(item.group);
        }
      } else {
        this.tableGroupingList.push(item.grouping);
        this.tableSupplierItemHeader.grouping.push({
          grouping: item.grouping,
          group: [item.group],
        });
      }
      this.tableSupplierItemHeader.itemModel.indexOf(item.itemModel) == -1
        ? this.tableSupplierItemHeader.itemModel.push(item.itemModel)
        : null;
    });
  }

  async createTable() {
    var tableSupplierHTML = [];
    var tableSupplierHTMLObject = document.getElementById('table_supplier');
    var groupAux: String[] = [];
    tableSupplierHTML = [
      '<table class="table table-striped table-fit table-bordered table-hover">',
    ];
    tableSupplierHTML.push(
      '<thead class="table-primary"><tr ><th scope="col">Agrupador</th>'
    );
    this.tableSupplierItemHeader.grouping.forEach((groupingItem) => {
      tableSupplierHTML.push(
        '<th class="text-center" scope="col" colspan="' +
          groupingItem.group.length +
          '"><div><strong>' +
          groupingItem.grouping +
          '</strong></div></th>'
      );
    });
    tableSupplierHTML.push('</tr></thead>');
    tableSupplierHTML.push(
      '<thead class="table-secondary"><tr ><th scope="col">Grupo</th>'
    );
    this.tableSupplierItemHeader.grouping.forEach((groupingItem) => {
      groupingItem.group.forEach((groupItem) => {
        tableSupplierHTML.push(
          '<th class="text-center" scope="col"><div><strong>' +
            groupItem +
            '</strong></div></th>'
        );
        groupAux.push(groupItem);
      });
    });
    tableSupplierHTML.push('</tr></thead><tbody>');
    this.tableSupplierItemHeader.supplier.forEach((supplierItem) => {
      tableSupplierHTML.push(
        '<th scope="row"><strong>' + supplierItem + '<strong></th>'
      );
      var supplierFilter = this.supplierItem.filter((supplierFilterItem) => {
        return supplierFilterItem.supplierName == supplierItem;
      });
      groupAux.forEach((groupItem) => {
        var checkSupplierGroupItem = false;
        supplierFilter.forEach((supplierFilterItem) => {
          if (
            supplierFilterItem.group == groupItem &&
            !checkSupplierGroupItem
          ) {
            var legend = '';
            var twoWords =
              supplierFilterItem.status.search(' ') > -1 ? true : false;
            if (twoWords) {
              legend = legend != '' ? legend + ',' : legend;
              supplierFilterItem.status.split(' ').forEach((words) => {
                legend = legend + words.slice(0, 1);
              });
            } else {
              legend = supplierFilterItem.status.slice(0, 1);
            }

            tableSupplierHTML.push(
              '<td class="text-center">' + legend + '</td>'
            );
            checkSupplierGroupItem = true;
          }
        });
        checkSupplierGroupItem
          ? null
          : tableSupplierHTML.push('<td>' + ' ' + '</td>');
      });
      tableSupplierHTML.push('</tr>');
    });
    tableSupplierHTML.push('</tr></tbody>');
    tableSupplierHTML.push('</table>');
    tableSupplierHTML.forEach((element) => {
      this.tableSupplierHTMLString = this.tableSupplierHTMLString + element;
    });

    tableSupplierHTMLObject!.innerHTML = tableSupplierHTML.join('');
  }

  openModal(centerDataModal: any) {
    this.modalService.open(centerDataModal, {
      size: 'lg',
      centered: true,
      windowClass: 'modal-holder',
    });
  }

  openModalSmall(centerDataModal: any) {
    this.modalService.open(centerDataModal, {
      size: 'sm',
      centered: true,
      windowClass: 'modal-holder',
    });
  }

  /*filterSupplier(supplierName: string) {
    return this.supplierItem.filter((supplierFilterItem) => {
      return supplierFilterItem.supplierName == supplierName;
    });
  }

  filterSupplierAndGroup(supplierName: string, groupingItem: string) {
    return this.supplierItem.filter((supplierFilterItem) => {
      return (
        supplierFilterItem.supplierName == supplierName &&
        supplierFilterItem.grouping == groupingItem
      );
    });
  }

  indexGroup(groupingItem: string) {
    return this.tableSupplierItemHeader.grouping.findIndex((grouping) => {
      return grouping.grouping == groupingItem;
    });
  }*/

  filterModelByGroup(item: SupplierItem) {
    let itemModel: string[] = [];
    this.supplierItem.forEach((itemSupplier: SupplierItem) => {
      if (itemSupplier.group == item.group) {
        itemModel.push(itemSupplier.itemModel);
      }
    });
    this.filterModel = itemModel;
    return itemModel;
  }

  verifyExistItemModel(item: any) {
    let updateFilterList: string[] = [];
    this.filterModel.forEach((itemFilter: string) => {
      updateFilterList.push(
        itemFilter
          .trim()
          .slice(
            itemFilter.trim().startsWith('0') ? 1 : 0,
            itemFilter.trim().startsWith('0')
              ? 2
              : itemFilter.trim().startsWith('1')
              ? typeof itemFilter.trim().slice(1, 2).match(/[0-9]/gi) != null
                ? 2
                : 1
              : 1
          )
      );
    });
    let isValid =
      updateFilterList.findIndex((itemValidate: any) => {
        return (
          itemValidate ==
          item
            .trim()
            .slice(
              item.trim().startsWith('0') ? 1 : 0,
              item.trim().startsWith('0')
                ? 2
                : item.trim().startsWith('1')
                ? typeof item.trim().slice(1, 2).match(/[0-9]/gi) != null
                  ? 2
                  : 1
                : 1
            )
        );
      }) > -1
        ? false
        : true;
    this.filterModelBlock =
      typeof item.trim().slice(0, 2).match(/[0-9]/gi) == null
        ? false
        : !isValid;
  }

  templateSerial(item: SupplierItem) {
    let itemModelNumber = item.itemModel.trim().slice(0, 2).match(/[0-9]/gi);
    if (itemModelNumber == null) {
      return '';
    } else {
      return `${item.grouping
        .trim()
        .slice(0, 2)
        .toUpperCase()}${item.supplierName.trim().slice(0, 2).toUpperCase()}${
        itemModelNumber.length > 1
          ? item.itemModel.trim().slice(0, 2)
          : item.itemModel.trim().slice(0, 1)
      }00001`;
    }
  }

  updateModal(item: any, modal: any) {
    this.filterGroupSelect(item.grouping);
    this.filterModel = this.filterModelByGroup(item);
    this.filterModel = this.filterModel.filter((itemFilter: any) => {
      return itemFilter != item.itemModel;
    });
    this.updateSupplierItem = new SupplierItem(item);
    this.openModal(modal);
  }

  async updateItem(item: any, id: number) {
    this.supplierItemService
      .updateInsertItemSupplier(item, id)
      .subscribe((data) => {
        console.log(data);
        if (data[0].status == 200) {
          this.toastService.show('Atualizado com sucesso', {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
          this.initializeTable();
        } else {
          this.toastService.show('Erro ao atualizar - ' + data[0].statusText, {
            classname: 'bg-danger text-center text-white',
            delay: 10000,
          });
        }
      });
  }

  excludeItem(id: number) {
    this.supplierItemService.deleteItemSupplier(id).subscribe(
      () => {
        this.toastService.show('Excluído com sucesso', {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
        this.initializeTable();
      },
      (error: HttpErrorResponse) => {
        this.circularProgressiveWait = false;
        alert(error.message);
        this.toastService.show('Erro ao excluir - ' + error.message, {
          classname: 'bg-danger text-center text-white',
          delay: 10000,
        });
      }
    );
  }

  filterGroupSelect(groupingSelect: string) {
    var indexGroup = this.tableSupplierItemHeader.grouping.findIndex(
      (grouping) => {
        return grouping.grouping == groupingSelect;
      }
    );
    this.groupSelect =
      indexGroup != -1
        ? this.tableSupplierItemHeader.grouping[indexGroup].group
        : [];
  }
}

interface SupplierItemHeader {
  supplier: string[];
  grouping: [
    {
      grouping: string;
      group: string[];
    }
  ];
  itemModel: string[];
}
